<script lang="ts" context="module">
    export const name = "Infinite scroll";
</script>

<script lang="ts">
    import { z } from "zod";
    import Data from "@reperio-news/core.components/blocks/ContentList/Data";
    import ContentItem from "@reperio-news/core.components/blocks/ContentItem/View.svelte";
    import Hydrator from "@reperio-news/core.components/Hydrator.svelte";
    type Data = z.infer<typeof Data>;
    export let data: Data;
</script>

{#if data.content && data.content.items && data.content.items.length}
    {#each data.content.items as item}
        <ContentItem
            type="ContentItem"
            data={{
                content: item,
                layout: data.content_layout,
                custom_fields: data.content_custom_fields,
            }}
        />
    {/each}

    {#if !__ADMIN__}
        <Hydrator
            props={{
                already_loaded_ids: data.content.items.map((item) => item.id),
                data: {
                    ...data,
                    content: { ...data.content, items: [] },
                },
            }}
            component="InfiniteScrollBox"
            hydrate={true}
        />
    {/if}
{/if}
